import { Link } from "@tanstack/react-router"

import { SummaryAccordionItem } from "@/components/summary/SummaryAccordion"
import { AccordionContent } from "@/components/ui/accordion"

import type { CustomerApplications } from "@boundless/bl-api-client/customer/models"

type SummaryApplicationProps = {
  application: CustomerApplications
}

export function SummaryApplication({ application }: SummaryApplicationProps) {
  return (
    <SummaryAccordionItem
      value="signed-application"
      title="Signed Application"
      checkIcon={application.fundingNeeds.isSigned}
    >
      <AccordionContent className="px-4 pt-2 pb-4">
        <div className="grid grid-cols-2 gap-y-1">
          {application.fundingNeeds.isSigned ? (
            <div className="contents">
              <div className="text-sm font-medium text-gray-600">
                Chosen Lender
              </div>
              <div className="text-sm">{application.lenderName}</div>
            </div>
          ) : (
            <div className="col-span-2 space-y-1 text-sm text-gray-600">
              <p>{"Application hasn't been signed yet. "}</p>
              {
                <Link
                  className="text-primary hover:underline"
                  to="/applications/$applicationUuid/sign"
                  params={{
                    applicationUuid: application.uuid,
                  }}
                >
                  Sign application here.
                </Link>
              }
            </div>
          )}
        </div>
      </AccordionContent>
    </SummaryAccordionItem>
  )
}
